import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import {
  buildStructuredData,
  canonicalUrlForPath,
  DEFAULT_OG_IMAGE,
  getSeoMeta,
  SITE_NAME,
  TWITTER_HANDLE,
} from "@/config/seo";

export function SeoHead() {
  const { pathname } = useLocation();
  const meta = getSeoMeta(pathname);
  const canonical = canonicalUrlForPath(pathname);
  const structuredData = buildStructuredData(pathname);
  const robotsContent = meta.noindex
    ? "noindex, nofollow"
    : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";

  return (
    <Helmet prioritizeSeoTags>
      <html lang="en-US" />
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords} />
      <meta name="author" content="reTHINK HOA" />
      <meta name="robots" content={robotsContent} />
      <meta name="googlebot" content={robotsContent} />
      <link rel="canonical" href={canonical} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={SITE_NAME} />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={TWITTER_HANDLE} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />

      <meta name="application-name" content={SITE_NAME} />
      <meta name="theme-color" content="#00b4d8" />

      <link rel="alternate" hrefLang="en-US" href={canonical} />
      <link rel="alternate" hrefLang="x-default" href={canonical} />

      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
